import {
    CORE_GET_RM_TAG_REQUEST,
    CORE_GET_RM_TAG_SUCCESS,
    CORE_GET_RM_TAG_FAILURE,

    CORE_GET_PD_TAG_REQUEST,
    CORE_GET_PD_TAG_SUCCESS,
    CORE_GET_PD_TAG_FAILURE,

    CORE_GET_DELIVERY_TAG_REQUEST,
    CORE_GET_DELIVERY_TAG_SUCCESS,
    CORE_GET_DELIVERY_TAG_FAILURE,

    CORE_GET_PO_RECEIPT_REQUEST,
    CORE_GET_PO_RECEIPT_SUCCESS,
    CORE_GET_PO_RECEIPT_FAILURE,

    CORE_GET_LIST_SO_REQUEST,
    CORE_GET_LIST_SO_SUCCESS,
    CORE_GET_LIST_SO_FAILURE,

    CORE_GET_SO_INFO_REQUEST,
    CORE_GET_SO_INFO_SUCCESS,
    CORE_GET_SO_INFO_FAILURE,

    REQUEST_STATE
} from '../types'

const requestState = REQUEST_STATE

export default {
    tagDatas: (state = requestState, action) => {
        switch (action.type) {
            case CORE_GET_RM_TAG_REQUEST:
            case CORE_GET_DELIVERY_TAG_REQUEST:
            case CORE_GET_PO_RECEIPT_REQUEST:
            case CORE_GET_LIST_SO_REQUEST:
                return state
            case CORE_GET_RM_TAG_SUCCESS:
            case CORE_GET_DELIVERY_TAG_SUCCESS:
            case CORE_GET_PO_RECEIPT_SUCCESS:
            case CORE_GET_LIST_SO_SUCCESS:
                if (action.payload) {
                    const { result, datas } = action.payload
                    if (result && datas) {
                        return datas
                    }
                    return []
                } else return []
            case CORE_GET_RM_TAG_FAILURE:
            case CORE_GET_DELIVERY_TAG_FAILURE:
            case CORE_GET_PO_RECEIPT_FAILURE:
            case CORE_GET_LIST_SO_FAILURE:
                return []
            default:
                return state
        }
    },
    tagData: (state = requestState, action) => {
        switch (action.type) {
            case CORE_GET_PD_TAG_REQUEST:
                return state
            case CORE_GET_PD_TAG_SUCCESS:
                if (action.payload && !Array.isArray(action.payload) && typeof action.payload === "object") {
                    const { result, data } = action.payload
                    if (result && data) {
                        return data
                    }
                    return {}
                } else return {}
            case CORE_GET_PD_TAG_FAILURE:
                return {}
            default:
                return state
        }
    },
    soPick: (state = requestState, action) => {
        switch (action.type) {
            case CORE_GET_SO_INFO_REQUEST:
                return state
            case CORE_GET_SO_INFO_SUCCESS:
                if (action.payload && !Array.isArray(action.payload) && typeof action.payload === "object") {
                    const { result, data } = action.payload
                    if (result && data) {
                        return data
                    }
                    return {}
                } else return {}
            case CORE_GET_SO_INFO_FAILURE:
                return {}
            default:
                return state
        }
    },
}



// WEBPACK FOOTER //
// ./src/app/redux/reducers/qrtag.js